export const CATEGORY_EDITED = 'settings/CATEGORY_EDITED';
export const categoryEdited = () => ({
  type: CATEGORY_EDITED,
});



// WEBPACK FOOTER //
// ./app-settings/actions/category-edited.js